import { getRequest, postRequest } from '@bo-apis/axios';

const getMemberCertInfoList = (siteNumber) =>
  getRequest({
    url: `api/v1/member-cert-info/site/${siteNumber}`,
  });

const createMemberCertInfo = (payload) =>
  postRequest({
    url: `api/v1/member-cert-info`,
    data: payload,
  });

export default {
  getMemberCertInfoList,
  createMemberCertInfo,
};
